module.exports = __webpack_public_path__ + "officialStatic/img/qua.584176a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/about/qua.png
// module id = XuRw
// module chunks = 0